import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DefaultPageRouteService } from '../../navigation/services/default-page-route.service';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class PublicRedirectGuard {
  private authService = inject(AuthenticationService);
  private defaultNavigation = inject(DefaultPageRouteService);

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isAuthorized()
      .pipe<boolean>(
        map<boolean, boolean>((isAuthorized: boolean): boolean => {
          if (isAuthorized) {
            this.defaultNavigation.routeToDefaultPage().catch((error: unknown) => console.error(error));

            return false;
          }

          return true;
        })
      );
  }
}
